<template>
	<div>
		<!-- 图片 -->
		<div class="Minister-top information uploadPictures">
			<div class="Minister-top-top Ministerbackground">
				<div class="Minister-top-left Minister-top-color">产品图片</div>
			</div>
			<div class="productimgs">
				<div class="fluid container">
					<draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
						:list="imgListSelect" handle=".list-group-item">
						<li class="list-group-item" v-for="(element, index) in imgListSelect" :key="element">
							<div class="mask" v-if="system == 5 && !isChakan">
								<i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
								<i class="custom-icon el-icon-delete" @click="handleRemoveSelect(index)"></i>
							</div>
							<div class="badge">
								<img :src="element" alt />
							</div>
						</li>
						<li v-if="system == 5 && !isChakan" @click="dialogVisibleSelect = true" class="avatar-uploader"
							slot="footer">
							<i data-v-c660ac10 class="el-icon-plus"></i>
						</li>
					</draggable>
				</div>
			</div>

		</div>
		<el-dialog title="选择图片" :visible.sync="dialogVisibleSelect" :modal-append-to-body="false" append-to-body
			width="1200px">
			<!--			<p>-->
			<!--				图片可批量上传，只支持-->
			<!--				<span style="color:red;font-weight:bold;"-->
			<!--				>JPG/TIFF/JPEG</span-->
			<!--				>-->
			<!--				格式图片，首选-->
			<!--				<span style="color:red;font-weight:bold;">JPEG</span>-->
			<!--				格式， 图片的最长边不应低于-->
			<!--				<span style="color:red;font-weight:bold;">1600</span>-->
			<!--				像素，最长边不得超过-->
			<!--				<span style="color:red;font-weight:bold;">10,000</span>-->
			<!--				像素，不能包含徽标或水印。商品必须是填满-->
			<!--				<span style="color:red;font-weight:bold;">85%</span>-->
			<!--				的图片,图片详细标准请参阅Amazon平台要求。-->
			<!--			</p>-->

			<draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
				:list="imgListUpdate" handle=".list-group-item">
				<el-upload class="upload-demo" ref="dialogSelect" accept="image/jpeg, image/tiff" drag multiple
					:action="action" list-type="picture-card" :on-success="handSuccess" :on-change="handChange"
					:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-error="handleError"
					:on-progress="handleProgress" :headers="customHeaders" :auto-upload="true">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">
						将文件拖到此处，或
						<em>选择图片</em>
					</div>
					<div class="el-upload__tip" slot="tip">
						只能上传JPG/PNG文件，且不超过2M
					</div>
				</el-upload>
				<div style="margin-top: 10px">
					<div style="display: flex;width: 100%;flex-wrap: wrap">
						<img v-for="(item, index) in lianjieUrlList" :key="index" :src="item" class="prduct_img" alt />
					</div>
					<el-button style="margin-top: 6px" type="primary" @click="lianjiedaoru">链接导入</el-button>
				</div>
			</draggable>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleSelect = false">取 消</el-button>
				<el-button type="primary" @click="sureImg">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleSee" width="500px" append-to-body>
			<img width="100%" :src="dialogImageUrl" alt />
		</el-dialog>
		<el-dialog :visible.sync="lianjieVisibleSee" width="900px" title="图片链接导入" append-to-body>
			<el-input type="textarea" placeholder="不同图片链接请用英文逗号隔开" v-model="lianjieUrl" maxlength="5000" show-word-limit
				:disabled="system < 5"></el-input>
			<div style="margin-top: 10px;color: red">不同图片链接请用英文逗号隔开</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="lianjieVisibleSee = false">取 消</el-button>
				<el-button type="primary" @click="sureLianjie">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import { ajaxPost, Baseurl } from '@/api/api/api'
export default {
	components: {
		draggable,
	},
	props: {
		pageType: {
			type: String,
			default() {
				return ''
			},
		},
	},
	created() {
		this.system = JSON.parse(localStorage.getItem('role')).system
	},
	data() {
		return {
			//是否为查看
			isChakan: false,
			lianjieUrl: '',
			lianjieUrlList: [],
			lianjieVisibleSee: false,
			system: 5,
			action: Baseurl + 'xgImage/uploadImage',
			dialogVisibleSelect: false,
			dialogVisibleSee: false,
			dialogImageUrl: '',
			imgList: '',
			imgListUpdate: [],
			//页面展示的图片
			imgListSelect: [],
			isDragging: false,
			customHeaders: { token: localStorage.getItem('token') },
			updateImageList: [],
			arr: [],
		}
	},
	methods: {
		addImgList(imgArr) {
			this.imgListSelect = imgArr
			this.$emit('ImgList', this.imgListSelect)
		},
		// 父组件添加图片相应
		addImg(file) {
			this.imgListSelect.push(file)
			this.$emit('ImgList', this.imgListSelect)
		},
		sureImg() {
			this.submitUpload()
			if (this.arr == true) {
				// this.$message.success('上传成功')
				let ss = this.imgListUpdate.map(item => {
					return item.response.data
				})
				if (this.lianjieUrl.length != 0) {
					this.imgListSelect = [...this.imgListSelect, ...ss, this.lianjieUrlList]
				} else {
					this.imgListSelect = [...this.imgListSelect, ...ss]
				}
				this.imgListUpdate = []
				this.lianjieUrlList = []
				this.$refs.dialogSelect.clearFiles()
				this.dialogVisibleSelect = false
				this.$emit('ImgList', this.imgListSelect)
			}
		},
		handleProgress(event, file, fileList) {
		},
		submitUpload() {
			this.$refs.dialogSelect.submit()
		},
		handSuccess(res, file, fileList) {
			this.arr = fileList.every((item) => item.response.code === 200)
			this.imgList = this.imgListUpdate.map((item) => item.response.data)
			if (this.arr == true) {
				this.$message.success('上传成功')
			} else {
				this.$message.error(res.data)
			}
		},
		handChange(file, fileList) {
			this.imgListUpdate = fileList
		},
		handleAvatarSuccess(response, file, fileList) {
			this.$message.success('上传成功')
			this.imgListUpdate = fileList
		},
		uploading(msg) {
			this.$message.success(msg)
		},
		handleError(err, file, fileList) {
			this.$message.error(err)
		},
		handlePictureCardPreview(file) {
			let imageUrl = ''
			if (Object.prototype.toString.call(file) === '[object Object]') {
				imageUrl = file.response.data
			} else {
				imageUrl = file
			}
			this.dialogImageUrl = imageUrl
			this.dialogVisibleSee = true
		},
		handleRemove(file, fileList) {
			this.imgListUpdate = fileList
		},
		handleRemoveSelect(index) {
			this.imgListSelect.splice(index, 1)
			this.$emit('ImgList', this.imgListSelect)
		},
		handleRemoveSelect2(index) {
			this.imgListUpdate.splice(index, 1)
		},
		downloadImgs() {
			this.$emit('downloadImgs')
		},
		//变体增加图片
		biantiaddImgList(imageList) {
			this.imgListSelect = this.imgListSelect.concat(imageList)
			this.$emit('ImgList', this.imgListSelect)
		},
		lianjiedaoru() {
			this.lianjieUrl = ''
			let url = ''
			if (this.lianjieUrlList.length > 0) {
				for (let i = 0; i < this.lianjieUrlList.length; i++) {
					url = url + this.lianjieUrlList[i] + ','
				}
			}
			this.lianjieUrl = url.slice(0, -1)
			this.lianjieVisibleSee = true
		},
		sureLianjie() {
			this.lianjieVisibleSee = false
			if (this.lianjieUrl) {
				this.lianjieUrlList = this.lianjieUrl.split(',')
			}
		}
	},
}
</script>

<style lang="scss" scoped>
::v-deep .upload-demo {
	.el-upload--picture-card {
		line-height: initial;

		.el-upload-dragger {
			width: 100%;
			height: 100%;
			border: none;
		}
	}
}

.Minister-top {
	width: 99%;
	border-radius: 4px;
	overflow: hidden;

	.Ministerbackground {
		background: #d7f0dbff;
	}

	.Minister-top-top {
		width: 100%;
		height: 40px;

		.Minister-top-left {
			width: 80px;
			line-height: 40px;
			float: left;
			text-align: center;
			font-size: 16px;
			color: #fff;
		}

		.Minister-top-color {
			// color: #567801;
			background: #39b54a;
		}
	}

	.information_content {
		width: calc(100% - 22px);
		overflow: hidden;
		padding: 10px 10px;
		border: 1px solid rgba(168, 168, 168, 0.8);
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		border-top: none !important;
		margin-bottom: 15px;

		.information_Mandarin {
			overflow: hidden;
			// margin-left: 4%;
			display: flex;
			justify-content: space-between;

			ul {
				max-width: 1450px;
				flex: 1;
				display: flex;

				li {
					width: 90px;
					height: 35px;
					line-height: 35px;
					text-align: center;
					// float: left;
					cursor: pointer;
				}

				.liactive {
					background: #2c8dff;
					color: #fff;
				}
			}
		}

		.information_tips {
			line-height: 50px;
			margin-left: 10%;
			color: #f89a9a;
			font-size: 16px;
		}

		.information_input {
			overflow: hidden;
			position: relative;

			.region {
				width: 80px;
				height: 80px;
				background: rgba(0, 0, 0, 0);
				// background: red;
				position: absolute;
				left: 0px;
				top: 50px;
			}

			.information_Title {
				width: 8%;
				overflow: hidden;
				color: #7d7171;
				text-align: right;
				float: left;
				line-height: 33px;
				margin-right: 1%;
				font-weight: bold;
				user-select: none;

				.tips {
					color: red;
				}
			}

			.input_el {
				width: 88%;
				float: left;

				.Preservation {
					float: right;
					padding: 10px 10px;
					background: #73ade9;
					color: #fff;
					margin-top: 5px;
					border-radius: 5px;
				}
			}
		}
	}
}

.uploadPictures {
	/deep/ .el-upload-list__item {
		width: 178px;
		height: 178px;
	}

	/deep/ .el-upload--picture-card {
		width: 178px;
		height: 178px;
		line-height: 178px;
		padding: 0 20px;
	}

	/deep/ .selectUpload {
		// .el-upload.el-upload--picture-card,
		.el-upload-list__item-status-label {
			display: none;
		}
	}

	/deep/ .el-dialog__body {
		word-break: break-word;
	}

	.flip-list-move {
		transition: transform 0.5s;
	}

	.no-move {
		transition: transform 0s;
	}

	.ghost {
		opacity: 0.5;
		background: #c8ebfb;
	}

	.list-group {
		display: flex;
		flex-wrap: wrap;
		overflow: hidden;

		.list-group-item {
			width: 178px;
			height: 178px;
			background-color: #fbfdff;
			border: 1px dashed #c0ccda;
			border-radius: 6px;
			box-sizing: border-box;
			cursor: pointer;
			margin-right: 10px;
			margin-bottom: 10px;
			// float: left;
			position: relative;
			overflow: hidden;

			.mask {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				background: rgba(0, 0, 0, 0.5);
				position: absolute;
				top: 0;
				left: 0;
				opacity: 0;
				transition-duration: 0.5s;

				.custom-icon {
					font-size: 20px;
					margin: 0 8px;
					color: #fff;
				}
			}

			&:hover .mask {
				opacity: 1;
				border-color: #409eff;
			}
		}

		.list-group-item img {
			width: 100%;
			height: 100%;
		}
	}

	.showImg {
		width: 148px;
		float: left;
		margin-right: 15px;
	}

	.avatar-uploader {
		width: 178px;
		height: 178px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
		text-align: center;
		line-height: 178px;
		font-size: 40px;

		&:hover {
			border-color: #409eff;
		}
	}
}

.productimgs {
	width: calc(100% - 22px);
	overflow: hidden;
	padding: 10px 10px;
	border: 1px solid rgba(168, 168, 168, 0.8);
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
	border-top: none !important;
	margin-bottom: 15px;
}

.prduct_img {
	height: 130px;
	width: 130px;
	margin: 0 10px 10px 0;
}

.red {
	color: red;
}
</style>
